import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const fetchCompanyWisePercentagePlaced = createAsyncThunk('fetchCompanyWisePercentagePlaced', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/reports/company-wise-percentage?year=${obj.year}`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const placementPercentagePlacedSlice = createSlice({
    name: 'ctcOffered',
    initialState: {
        loading: false,
        percentageWisePlaced: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCompanyWisePercentagePlaced.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchCompanyWisePercentagePlaced.fulfilled, (state, action) => {
            state.loading = false;
            state.percentageWisePlaced = action.payload
        })
        builder.addCase(fetchCompanyWisePercentagePlaced.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default placementPercentagePlacedSlice.reducer